import styled, { css } from "styled-components";

const baseTextStyle = css`
  font-size: 1rem;
  margin: 0;
  padding: 0;
`;

const centerText = css`
  text-align: center;
`;

type TitleProps = {
  centered?: boolean;
};

export const SectionTitle = styled.h3<TitleProps>`
  ${baseTextStyle};
  color: ${({ theme }) => theme.colorTextMain};
  font-family: "Vy Sans", sans-serif;
  font-weight: bold;
  ${({ centered }) => centered && centerText};
`;

/**
 * REVIEW-SPOR: Semantic font "SM Heading" from the Figma design, not available in the installed Spor typography.
 */
export const SMHeading = styled.h3`
  ${baseTextStyle};
  color: ${({ theme }) => theme.colorTextMain};
  font-family: "Vy Sans", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
`;

/**
 * REVIEW-SPOR:Figma "Heading/ML Heading", not available in the installed Spor typography.
 */
export const MLHeading = styled.h3`
  ${baseTextStyle};
  color: ${({ theme }) => theme.colorTextMain};
  font-family: "Vy Sans", sans-serif;
  font-size: 21px;
  line-height: 31.5px;
  font-weight: 700;
  letter-spacing: 0;
`;

/**
 * REVIEW-SPOR: Semantic font "Label/SM Label" from the Figma design, not available in the installed Spor typography.
 */
export const SMLabel = styled.p`
  ${baseTextStyle};
  color: ${({ theme }) => theme.colorTextMain};
  font-family: "Vy Sans", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
`;

/**
 * REVIEW-SPOR: Semantic font "Heading/LG Heading" from the Figma design, not available in the installed Spor typography.
 */
export const LGHeading = styled.h3`
  ${baseTextStyle};
  color: ${({ theme }) => theme.colorTextMain};
  font-family: "Vy Sans", sans-serif;
  font-size: 24px;
  line-height: 36px;
  font-weight: 700;
`;

/**
 * REVIEW-SPOR: Semantic font "Paragraph/LG Paragraph" from the Figma design, not available in the installed Spor typography.
 */
export const LGParagraph = styled.p`
  ${baseTextStyle};
  color: ${({ theme }) => theme.colorTextMain};
  font-family: "Vy Sans", sans-serif;
  font-size: 24px;
  line-height: 36px;
  font-weight: 400;
`;

/**
 * REVIEW-SPOR: Semantic font "MD Heading" from the Figma design, not available in the installed Spor typography.
 */
export const MDHeading = styled.h3`
  ${baseTextStyle};
  color: ${({ theme }) => theme.colorTextMain};
  font-family: "Vy Sans", sans-serif;
  font-size: 18px;
  line-height: 27px;
  font-weight: 700;
`;

/**
 * REVIEW-SPOR: Semantic font "Paragraph/MD Paragraph" from the Figma design, not available in the installed Spor typography.
 */
export const MDParagraph = styled.p`
  ${baseTextStyle};
  color: ${({ theme }) => theme.colorTextMain};
  font-family: "Vy Sans", sans-serif;
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
`;

type TextProps = {
  bold?: boolean;
  secondary?: boolean;
  truncated?: boolean;
};

export const Text = styled.p<TextProps>`
  ${baseTextStyle};
  line-height: 1.33rem;
  word-break: break-word;
  font-family: "Vy Sans", sans-serif;
  font-weight: ${({ bold }) => (bold ? `bold` : `normal`)};
  color: ${({ secondary, theme }) =>
    secondary ? theme.colorTextSecondary : theme.colorTextMain};

  ${({ truncated }) =>
    truncated &&
    css`
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    `}
`;
